import ModelEditDto from 'app/admin/model/dto/ModelEditDto';
import HysysModelInputAttributeEditDto from './HysysModelInputAttributeEditDto';
import HysysModelOutputAttributeEditDto from './HysysModelOutputAttributeEditDto';

export class HysysModelEditDto extends ModelEditDto {
	constructor() {
		super();
		/** @type {string} */
		this.hsc_file = null;
		/** @type {HysysModelInputAttributeEditDto[]} */
		this.inputAttributes = null;
		/** @type {HysysModelOutputAttributeEditDto[]} */
		this.outputAttributes = null;
	}

	/**
	 * @typedef {Object} _HysysModelEditDtoProps
	 * @property {string} hsc_file
	 * @property {HysysModelInputAttributeEditDto[]} inputAttributes
	 * @property {HysysModelOutputAttributeEditDto[]} outputAttributes
	 *
	 * @typedef {import("app/admin/model/dto/ModelEditDto").ModelEditDtoProps & _HysysModelEditDtoProps} HysysModelEditDtoProps
	 */
	/**
	 *
	 * @param {HysysModelEditDtoProps} props
	 * @returns {HysysModelEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.hsc_file = props.hsc_file;
		this.inputAttributes = props.inputAttributes !== null ? props.inputAttributes.map(d => new HysysModelInputAttributeEditDto().setup(d)) : [];
		this.outputAttributes = props.outputAttributes !== null ? props.outputAttributes.map(d => new HysysModelOutputAttributeEditDto().setup(d)) : [];
		return this;
	}
}

export default HysysModelEditDto;
